var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M569.9 921.1H228V139h97.2c8.5 17.7 26.5 29.9 47.3 29.9h279.1c20.8 0 38.9-12.3 47.3-29.9h96.7v458.1c0 11 9 20 20 20s20-9 20-20V130.3c0-17.3-14.3-31.3-31.8-31.3H701.1c-7.2-20.3-26.7-35-49.5-35H372.5c-22.7 0-42.2 14.7-49.5 35H219.7c-17.5 0-31.8 14-31.8 31.3v799.6c0 17.3 14.3 31.3 31.8 31.3h350.2c11 0 20-9 20-20s-8.9-20.1-20-20.1z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M706.4 404.6c0-11-9-20-20-20H319.1c-5.4-5.3-12.8-8.6-21.1-8.6-16.6 0-30 13.4-30 30s13.4 30 30 30c9.5 0 18-4.4 23.5-11.4h364.9c11 0 20-9 20-20zM706.4 542.1c0-11-9-20-20-20H322.1c-5.5-7.4-14.2-12.1-24.1-12.1-16.6 0-30 13.4-30 30s13.4 30 30 30c7.8 0 14.9-3 20.3-7.9h368.1c11 0 20-9 20-20zM320.1 660.6h-0.9c-5.4-5.4-12.9-8.8-21.2-8.8-16.6 0-30 13.4-30 30s13.4 30 30 30c9.5 0 17.9-4.4 23.4-11.2h297.2c11 0 20-9 20-20s-9-20-20-20H320.1zM950.2 529.4c-9.8-5.1-21.9-1.3-27 8.5L729.1 911l-143.6-78.6c-9.6-5.3-21.9-1.7-27.1 7.9-5.3 9.6-1.7 21.9 7.9 27.1l162.1 88.8c9.6 5.3 21.9 1.7 27.1-7.9 0.9-1.7 1.6-3.5 2-5.3l201.2-386.5c5.1-9.8 1.3-22-8.5-27.1z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M723.8 335.1h-429c-14.8 0-26.8-12-26.8-26.8v-81.4c0-14.8 12-26.8 26.8-26.8h429c14.8 0 26.8 12 26.8 26.8v81.4c0 14.8-12 26.8-26.8 26.8z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.8f24084e8331dccfc45110791f4a86d4.svg";
export { ForwardRef as ReactComponent };